import React from 'react';
import classnames from 'classnames';
import classes from './notification.scss';
const Notification = ({
  className,
  message
}) => /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.message, className)
}, message);
export default Notification;